import { LazyLoadedZeroQueryContext } from "../../types/searchbox";
import { IPersonalizationPayload } from "../../types/suggestion-response";
import { fetchPersonalizedSuggestions } from "./fetch";

let fetchPromise: Promise<IPersonalizationPayload> | null = null;

export function initPersonalization(
    context: LazyLoadedZeroQueryContext,
    isPrivateCustomer: boolean
): void {
    if (fetchPromise) return;
    fetchPromise = fetchPersonalizedSuggestions(context, isPrivateCustomer);
}

export function getPersonalization(): Promise<IPersonalizationPayload> {
    if (!fetchPromise) {
        throw new Error("Store not initialized. Call initPersonalization() first.");
    }
    return fetchPromise;
}
